module.exports = __webpack_public_path__ + "assets/img/InformationRecommendation.f2f0eb00.png";